import React from 'react'
import { Column, Row, Text } from '@/components/core'
import { classNameBuilder } from '@/helpers'

export default function ResultCard({
  id,
  title,
  indicatorColor,
  indicatorPosition,
  children,
  variant = 'default'
}: {
  id: string
  title?: string
  variant?: 'default' | 'highlight' | 'warning'
  indicatorColor?: 'blue' | 'orange' | 'green' | 'cian'
  indicatorPosition?: 'top' | 'left'
  children: React.ReactNode
}) {
  return (
    <Column
      id={id}
      className={classNameBuilder(
        'w-full items-center self-center rounded-xl bg-white shadow lg:w-[930px] lg:bg-gradient-128deg lg:from-white',
        variant === 'default' && 'lg:to-[#F9F5FF]',
        variant === 'highlight' && 'lg:to-[#8B5CF6]',
        variant === 'warning' && 'lg:to-[#dada66]'
      )}
    >
      <Column
        className={classNameBuilder(
          'relative w-full rounded-2xl lg:p-16',
          indicatorPosition &&
            {
              top: `before:absolute before:-top-[0px] before:mt-[-2px] before:h-2 before:w-10 before:self-center before:rounded-full`,
              left: 'before:absolute before:-top-1 before:h-2 before:w-10 before:rounded-full  max-lg:before:self-center lg:before:-left-1 lg:before:top-16 lg:before:h-10 lg:before:w-2'
            }[indicatorPosition],
          indicatorColor &&
            {
              blue: 'before:bg-[#03A0F9]',
              orange: 'before:bg-[#F99603]',
              green: 'before:bg-[#08AD85]',
              cian: 'before:bg-[#09D4E1]'
            }[indicatorColor]
        )}
      >
        {title && (
          <Row className="w-full justify-start max-lg:mt-10 max-lg:justify-center lg:mb-10">
            <Text.Translated
              translationKey={title}
              className="justify-center self-start text-[28px] max-lg:text-center max-lg:text-[18px]"
              fontWeight="bold"
              color="600"
            />
          </Row>
        )}
        <Column className="w-full space-y-4 max-lg:py-8">{children}</Column>
      </Column>
    </Column>
  )
}
